import { Row } from "antd";
import styled from "styled-components";

export const ContentSection = styled.section<{ background?: string }>`
  position: relative;
  padding-bottom: 4rem;

  @media (max-width: 1024px) {
    padding-bottom: 0rem;
  }
`;

export const StyledRow = styled(Row) <{ direction: string }>`
  flex-direction: ${({ direction }) => (direction === "left" ? "row" : "row-reverse")};
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  overflow: hidden;
  background-color: #2159A6;
  min-height: 180px;
  padding: 20px 0;

  max-width: 900px;
  margin: -90px auto 0 auto;


  border: 4px solid white;
  border-radius: 20px;

  @media (max-width: 1024px) {
    margin: -60px auto 0 auto;
  }
  @media (max-width: 992px) {
    max-width: 100%;
    margin: -20px auto 0 auto;
  }
`;




export const ContentWrapper = styled("div")`
  position: relative;
  max-width: 540px;
  padding-left: 50px;

  @media only screen and (max-width: 575px) {
    padding-top: 4rem;
  }
`;

export const ServiceWrapper = styled("div")`
  display: flex;
  justify-content: space-between;
  max-width: 100%;
`;

export const MinTitle = styled("h6")`
  font-size: 50px;
  line-height: 1rem;
  padding: 0.5rem 0;
  text-transform: uppercase;
  color: #FFFFFF;
  font-family: "Gilroy Bold", sans-serif;

  @media (max-width: 992px) {
    font-size: 40px;
  }

  @media (max-width: 768px) {
    font-size: 48px;
  }

  @media (max-width: 480px) {
    font-size: 36px;
  }
`;

export const MinPara = styled("p")`
  font-size: 18px;
  line-height: 1rem;
  color: #FFFFFF;
  font-family: "Gilroy Light", sans-serif;
`;


export const ButtonWrapper = styled("div")`
  display: flex;
  justify-content: space-between;
  max-width: 100%;

  @media screen and (min-width: 1024px) {
    max-width: 80%;
  }

  button:last-child {
    margin-left: 20px;
  }
`;
export const VerticalDivider = styled.div`
  width: 1px;
  height: 80px;
  background-color: white;
  margin: 0 20px;
  display: inline-block;

  @media screen and (max-width: 768px) {
    margin: 0 0 1rem 0;
    height: 1px;
    width: 80%;
    display: block;
  }
`;
